import { isEmpty } from "lodash";

const RenderOddsBookmaker = ({
  component,
  handelChange,
  odds_lay,
  odds_back,
  item,
  limit,
  disabelBack,
  disabelLay,
  conditionNew,
  oldBack,
  oldLay,
  disableFull,
  ms,
  betType,
  active,
}) => {
  let checkDisabled = (odds) => {
    if (Number(odds) > 0) {
      if (Number(odds) > limit?.oddsLimit) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  let check = (odds) => {
    if (!conditionNew) {
      if (Number(odds) > 0 || !isEmpty(odds)) {
        if (Number(odds) > limit?.oddsLimit) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  return (
    <div
      data-v-635307b5
      className="s-bg-bookmaker-market s-w-129px s-relative s-grid s-grid-cols-2 s-gap-x-2 s-p-1 s-rounded-3px s-self-start s-h-48px"
    >
      {odds_back?.length > 0 ? (
        odds_back?.slice(0, 1)?.map((res, id) => {
          let chamak =
            oldBack?.length > 0
              ? res?.rt != oldBack[id]?.rt || res?.bv != oldBack[id]?.bv
              : false;
          return (
            <div 
              onClick={(e) => {
                if (disabelBack) {
                } else {
                  if (!checkDisabled(res?.rt)) {
                    handelChange(
                      res,
                      "back",
                      item?.RunnerName || item?.runnerName,
                      item,
                      e
                    );
                  }
                }
              }}
              style={check(res?.rt) ? { cursor: "not-allowed"} : {}}
              data-v-21a9d2fa
              data-v-635307b5
              className={`${
                active && betType == "back" ? "back-active" : ""
              } s-h-42px s-text-center s-rounded-3px s-border s-border-white s-flex s-items-center s-justify-center s-relative s-overflow-hidden s-bg-back-300 dark:s-bg-back-400-dark ${
                chamak ? "s-animate-spark-back" : ""
              }`}
              title="BACK"
            >
              {" "}
              {check(res?.rt) && ms == 1 && (
                <div className="s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-129px s-h-full s-bg-black-600 dark:s-bg-black-800 s-opacity-80 s-text-11px s-text-white s-rounded-3px s-z-20" />
              )}
              <p style={{color:"black"}}
                data-v-21a9d2fa
                className="s-text-17px s-font-bold s-text-global-font-default-light"
              >
                {res?.rt || ""}
              </p>
            </div>
          );
        })
      ) : (
        <div
          data-v-21a9d2fa
          data-v-635307b5
          className={`s-h-42px s-text-center s-rounded-3px s-border s-border-white s-flex s-items-center s-justify-center s-relative s-overflow-hidden s-bg-back-300 dark:s-bg-back-400-dark`}
          title="BACK"
        >
          <p
            data-v-21a9d2fa
            className="s-text-17px s-font-bold s-text-global-font-default-light"
          ></p>
        </div>
      )}
      {odds_lay?.length > 0 ? (
        odds_lay?.slice(0, 1)?.map((res, id) => {
          let chamak =
            oldLay?.length > 0
              ? res?.rt != oldLay[id]?.rt || res?.bv != oldLay[id]?.bv
              : false;
          return (
            <div
              data-v-21a9d2fa
              data-v-635307b5
              onClick={(e) => {
                if (disabelLay) {
                } else {
                  if (!checkDisabled(res?.rt)) {
                    handelChange(
                      res,
                      "lay",
                      item?.RunnerName || item?.runnerName,
                      item,
                      e
                    );
                  }
                }
              }}
              style={check(res?.rt) ? { cursor: "not-allowed" } : {}}
              className={`${
                active && betType == "lay" ? "lay-active" : ""
              } s-h-42px s-text-center s-rounded-3px s-border s-border-white s-flex s-items-center s-justify-center s-relative s-overflow-hidden s-bg-lay-300 dark:s-bg-lay-400-dark ${
                chamak ? "s-animate-spark-lay" : ""
              }`}
              title="LAY"
            >
              {" "}
              {check(res?.rt) && ms == 1 && (
                <div className="s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-129px s-h-full s-bg-black-600 dark:s-bg-black-800 s-opacity-80 s-text-11px s-text-white s-rounded-3px s-z-20" />
              )}
              <p style={{color:"black"}}
                data-v-21a9d2fa
                className="s-text-17px s-font-bold s-text-global-font-default-light"
              >
                {res?.rt || ""}
              </p>
            </div>
          );
        })
      ) : (
        <div
          data-v-21a9d2fa
          data-v-635307b5
          className={`s-h-42px s-text-center s-rounded-3px s-border s-border-white s-flex s-items-center s-justify-center s-relative s-overflow-hidden s-bg-lay-300 dark:s-bg-lay-400-dark`}
          title="LAY"
        >
          <p
            data-v-21a9d2fa
            className="s-text-17px s-font-bold s-text-global-font-default-light"
          ></p>
        </div>
      )}
      {disableFull && ms == 1 && (
        <div class="s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-full s-h-full s-bg-black-600 dark:s-bg-black-800 s-opacity-80 s-text-15px s-text-white s-rounded-3px s-z-20">
          Suspended
        </div>
      )}
    </div>
  );
};

export default RenderOddsBookmaker;
